import { fetcher } from '../utils'
import { ComponentDestinationVO } from '@repo/types'

export default async (connectionKey: string, isTakeChat: boolean): Promise<ComponentDestinationVO[]> =>
  fetcher(`api/transfer/destinations/${connectionKey}?takeChat=${isTakeChat}`, 'GET', undefined)
